import { z } from "zod";
import { FUNNEL_TEMPLATE_IDS, ProjectionInputsSchema, ProductSchema, TrafficChannelSchema,
  FunnelExpenseSchema, RegionalSettingsSchema, ScenarioSnapshotSchema } from "../funnel-planner/schema";

// Narrow the existing domain contracts; never accept contact, consent, receipts,
// advisory provenance, arbitrary graph payloads, or persisted identity fields.
export const buildPlanSchema = z.strictObject({
  templateId: z.enum(FUNNEL_TEMPLATE_IDS).optional(),
  audience: z.enum(["agency", "franchise", "creator", "adult", "enterprise"]).optional(),
  goal: z.string().max(280).optional(),
  projectionInputs: ProjectionInputsSchema.extend({ reinvestmentCap: z.number().min(0).max(1e9).optional() }).strict().optional(),
  products: z.array(ProductSchema.strict()).max(8).optional(),
  trafficChannels: z.array(TrafficChannelSchema.strict()).max(12).optional(),
  expenses: z.array(FunnelExpenseSchema.strict()).max(32).optional(),
  regionalSettings: RegionalSettingsSchema.strict().optional(),
  scenarios: z.array(ScenarioSnapshotSchema.strict()).max(8).optional(),
  step: z.number().int().min(1).max(7).optional(),
});
export const reverseGoalSchema = z.strictObject({
  goalType: z.enum(["profit", "revenue", "leads", "customers", "booked_calls", "cac", "payback"]),
  targetValue: z.number().positive().max(1e9),
});
export const canvasEditSchema = z.strictObject({
  // Edit known nodes only. Deletion, replacement, edge rewiring and imported
  // graph execution remain human-controlled; an agent cannot erase a graph.
  edits: z.array(z.strictObject({
    id: z.string().min(1).max(80),
    label: z.string().min(1).max(40).optional(),
    conversionRate: z.number().min(0.1).max(100).optional(),
    position: z.strictObject({ x: z.number().min(-10000).max(10000), y: z.number().min(-10000).max(10000) }).optional(),
  })).min(1).max(12),
});
